import BusinessCapitalCallPortion from "./BusinessCapitalCallPortion";

export default BusinessCapitalCallPortion;
